<template>
  <div class="home">
    <div class="top-white-box"></div>
    
    <div class="top-gray-box daily-deals-gray-box">
      <div><h1>Daily Deals</h1></div>
      <div class="daily-deals-date">{{dailyDate}}</div>
    </div>

    <!--<GiveawayBox />-->
    <Deals :date="dailyDate" />


    <app-modal/>
  </div>
</template>

<script>
// @ is an alias to /src
import Deals from '@/components/Deals.vue'
import settings from '@/settings'
import moment from 'moment'

export default {
  name: 'home',
   data() {
        return {
            dailyDate: false
        }
  },
  created(){
    this.dailyDate = moment(this.$route.params.date).format('YYYY-MM-DD');

    document.title = settings.siteNameCaps + ' | ' + this.dailyDate + ' Daily Deals';
  },
  computed: {
    settings: function(){ return settings; },
  },
  components: {
    Deals
  }
}
</script>